/**
 * @file 本だなの資料への学習の記録が StudyProgressLog.detail に載せる JSON。
 *
 * @what: どの資料 (StudySource) への取り組みかを持つ。ページ範囲・分・様子・写真は
 *   StudyProgressLog の既存フィールドに入るので、ここには持たない。
 * @why: 教材 (StudyPlan.Materials) と違い、本だなの資料は plan に登録しないので
 *   material_id では指せない。読書 (readingLog) と同じく紐づけを detail に持つ。
 *   資料名を写すのは、資料を消しても記録が読めなくなってはいけないためである。
 *   将来の対象 (本ごとの独自コンテンツ等) は kind を分けて足す (この形は変えない)。
 * @failure: parse は例外を投げない。壊れた detail・知らない形は null を返す。
 */

/** 資料への学習の記録の種別。detail の先頭の判別に使う (readingLog と同じやり方)。 */
export const SOURCE_STUDY_LOG_KIND = "source_study";

export interface SourceStudyLogDetail {
  kind: typeof SOURCE_STUDY_LOG_KIND;
  /** 本だなの資料 id。 */
  source_id: string;
  /** 記録した時点の資料名。 */
  source_title: string;
}

/**
 * 資料への学習の記録かを判別する。
 *
 * @what: 文字列の前置き判定で絞ってから JSON parse で確定し、様子の文などに同じ文字列が
 *   紛れても誤判定しない。
 */
export function parseSourceStudyLog(log: {
  detail?: string | undefined;
}): SourceStudyLogDetail | null {
  const d = log.detail;
  if (d === undefined || !d.includes(SOURCE_STUDY_LOG_KIND)) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(d);
  } catch {
    return null;
  }
  if (typeof parsed !== "object" || parsed === null) return null;
  const o = parsed as { kind?: unknown; source_id?: unknown; source_title?: unknown };
  if (o.kind !== SOURCE_STUDY_LOG_KIND) return null;
  if (typeof o.source_id !== "string" || o.source_id === "") return null;
  return {
    kind: SOURCE_STUDY_LOG_KIND,
    source_id: o.source_id,
    source_title: typeof o.source_title === "string" ? o.source_title : "",
  };
}

/** detail に載せる文字列を作る。 */
export function serializeSourceStudyLog(source: { id: string; title: string }): string {
  const detail: SourceStudyLogDetail = {
    kind: SOURCE_STUDY_LOG_KIND,
    source_id: source.id,
    source_title: source.title,
  };
  return JSON.stringify(detail);
}
